import { jsPDF } from 'jspdf';
import type { Driver, Company } from '../types';

interface CertificateData {
  driver: Driver;
  company: Company;
  score: number;
  completedAt: string;
}

export async function generateCertificatePDF(data: CertificateData): Promise<Blob> {
  // Create new PDF document
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  // Set background color
  doc.setFillColor(250, 250, 250);
  doc.rect(0, 0, 297, 210, 'F');

  // Add decorative border
  doc.setDrawColor(124, 58, 237); // Purple
  doc.setLineWidth(1);
  doc.rect(10, 10, 277, 190);
  doc.setLineWidth(0.5);
  doc.rect(12, 12, 273, 186);

  // Add certificate title
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(36);
  doc.setTextColor(124, 58, 237); // Purple
  doc.text('CERTIFICADO', 148.5, 50, { align: 'center' });

  // Add decorative line
  doc.setDrawColor(124, 58, 237);
  doc.setLineWidth(0.5);
  doc.line(98.5, 55, 198.5, 55);

  // Add certificate text
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(16);
  doc.setTextColor(75, 85, 99); // Gray-600
  doc.text('Certificamos que', 148.5, 80, { align: 'center' });

  // Add driver name
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(24);
  doc.setTextColor(17, 24, 39); // Gray-900
  doc.text(data.driver.name, 148.5, 95, { align: 'center' });

  // Add completion text
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(16);
  doc.setTextColor(75, 85, 99); // Gray-600
  doc.text(
    `concluiu com êxito o treinamento da ${data.company.name} com`,
    148.5,
    115,
    { align: 'center' }
  );

  // Add score
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(24);
  doc.setTextColor(124, 58, 237); // Purple
  doc.text(`${data.score.toFixed(1)}%`, 148.5, 130, { align: 'center' });

  // Add completion text
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(16);
  doc.setTextColor(75, 85, 99); // Gray-600
  doc.text('de aproveitamento.', 148.5, 145, { align: 'center' });

  // Add date
  const date = new Date(data.completedAt);
  const formattedDate = date.toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  doc.text(
    `${data.driver.city}, ${formattedDate}`,
    148.5,
    170,
    { align: 'center' }
  );

  // Return as blob
  return doc.output('blob');
}